// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

import recordFileService from '../../services/record-file-service';
import { fetchSharedFileThumb } from '../../actions/shared';
import { fetchResourceFileThumb } from '../../actions/files';

import { ThumbType } from '../../types/file';

import Loader from './Loader';
import { isLoaded } from '../../utils/redux-utils';

type State = {
  src: string,
  error: ?string,
  loading: boolean
}

type Props = {
  fileID: number,
  token: string, // resource viewer token
  recordID: number,
  sharedThumb: ThumbType,
  fileThumb: ThumbType,
  fetchSharedThumb: (token: string, resourceID: number, fileID: number) => void,
  fetchFileThumb: (fileId: number) => void,
  loading: boolean,
  error: string
}

class FileThumbnail extends Component {
  state: State = {
    src: '',
    error: '',
    loading: true
  };

  props: Props;

  componentWillMount() {
    const { token, fileID, recordID, fetchSharedThumb, fetchFileThumb } = this.props;
    if (token) {
      fetchSharedThumb(token, recordID, fileID);
    } else {
      fetchFileThumb(fileID);
      recordFileService
        .view(fileID)
        .then((blob) => {
          this.setState({
            src: window.URL.createObjectURL(blob),
            size: blob.size,
            loading: false
          });
        })
        .catch((error) => this.setState({ error }));
    }
  }

  render() {
    let { src, error, loading } = this.state;
    const { sharedThumb, fileThumb, token } = this.props;
    if (token && isLoaded(sharedThumb)) {
      loading = this.props.loading;
      src = window.URL.createObjectURL(sharedThumb);
      error = this.props.error;
    } else if (isLoaded(fileThumb)) {
      loading = this.props.loading;
      src = window.URL.createObjectURL(fileThumb);
      error = this.props.error;
    } else if (!this.props.loading && !isLoaded(sharedThumb) && !isLoaded(fileThumb)) {
      loading = this.props.loading;
      error = 'We could not load this thumbnail.';
    }
    console.log(`Error loading thumbnail: ${error}`);
    return (
      <div
        className='preview'
      >
        {loading && <Loader isLoading />}
        {src &&
          <img src={src} alt='' />
        }
        {/* <Text paragraph id='flash' className='is-error'>{error}</Text> */}
      </div>
    );
  }
}

const mapStateToProps = (appState) => ({
  loading: appState.sharedFile && appState.sharedFile.thumb && appState.sharedFile.thumb.loading,
  sharedThumb: appState.sharedFileThumb && appState.sharedFileThumb.data,
  fileThumb: appState.fileThumb && appState.fileThumb.data,
  error: appState.sharedFile && appState.sharedFile.thumb && appState.sharedFile.thumb.error
});

const mapDispatchToProps = (dispatch) => ({
  fetchSharedThumb: ((token, resourceID, fileID) =>
    dispatch(fetchSharedFileThumb(token, resourceID, fileID))),
  fetchFileThumb: ((fileId) =>
    dispatch((fetchResourceFileThumb(fileId)))
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FileThumbnail);




// WEBPACK FOOTER //
// ./src/components/shared/FilePreview.js